import { render, staticRenderFns } from "./subComponentsBak.vue?vue&type=template&id=22a8deae&scoped=true"
import script from "./subComponentsBak.vue?vue&type=script&lang=js"
export * from "./subComponentsBak.vue?vue&type=script&lang=js"
import style0 from "./subComponentsBak.vue?vue&type=style&index=0&id=22a8deae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8deae",
  null
  
)

export default component.exports